var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_20787)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_931_20787)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.5485C10.3618 2.5485 2.5485 10.3618 2.5485 20C2.5485 29.6381 10.3618 37.4514 20 37.4514C29.6381 37.4514 37.4514 29.6381 37.4514 20C37.4514 10.3618 29.6381 2.5485 20 2.5485ZM2.45142 20C2.45142 10.3082 10.3082 2.45142 20 2.45142C29.6918 2.45142 37.5485 10.3082 37.5485 20C37.5485 29.6918 29.6918 37.5485 20 37.5485C10.3082 37.5485 2.45142 29.6918 2.45142 20Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9514 0H20.0485V40H19.9514V0Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 19.9512L40 20.0483L-4.24382e-09 20.0483L0 19.9512L40 19.9512Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2524 0H33.3495V40H33.2524V0Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.301 0H13.3981V40H13.301V0Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6019 0H26.699V40H26.6019V0Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65051 0H6.7476V40H6.65051V0Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 33.252L40 33.349L-4.24382e-09 33.349L0 33.252L40 33.252Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13.3008L40 13.3979L-4.24382e-09 13.3979L0 13.3008L40 13.3008Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26.6016L40 26.6986L-4.24382e-09 26.6986L0 26.6016L40 26.6016Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 6.65039L40 6.74748L-4.24382e-09 6.74748L0 6.65039L40 6.65039Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_931_20787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20H40V27.2C40 31.6804 40 33.9206 39.1281 35.6319C38.3611 37.1372 37.1372 38.3611 35.6319 39.1281C33.9206 40 31.6804 40 27.2 40H12.8C8.31958 40 6.07937 40 4.36808 39.1281C2.86278 38.3611 1.63893 37.1372 0.871948 35.6319C0 33.9206 0 31.6804 0 27.2V20Z",
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_931_20787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.931 26.9888H25.3103C25.3103 28.2297 24.8167 29.4197 23.938 30.2972C23.0593 31.1746 21.8676 31.6675 20.6249 31.6675C19.3822 31.6675 18.1905 31.1746 17.3118 30.2972C16.4331 29.4197 15.9395 28.2297 15.9395 26.9888H11.254C11.254 29.4705 12.2413 31.8507 13.9987 33.6055C15.7561 35.3604 18.1396 36.3463 20.6249 36.3463C23.1102 36.3463 25.4937 35.3604 27.2511 33.6055C29.0085 31.8507 29.9958 29.4705 29.9958 26.9888H29.9282",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6236 5.00001V9.67877C21.8663 9.67877 23.058 10.1717 23.9367 11.0491C24.8154 11.9266 25.3091 13.1166 25.3091 14.3575C25.3091 14.4387 25.3091 14.5199 25.3091 14.5997C25.2478 15.7875 24.7359 16.9075 23.8773 17.7319C23.0188 18.5562 21.878 19.0232 20.687 19.0377H20.5657C19.375 19.0228 18.2346 18.5557 17.3763 17.7314C16.518 16.9071 16.0063 15.7873 15.9451 14.5997H11.2596C11.3215 17.0298 12.328 19.3405 14.0659 21.0426C15.8039 22.7447 18.137 23.7046 20.5713 23.7192H20.6925C23.127 23.705 25.4605 22.7452 27.1987 21.043C28.937 19.3409 29.9436 17.03 30.0055 14.5997C30.0055 14.5185 30.0055 14.4387 30.0055 14.3575C30.0055 13.1278 29.7628 11.91 29.2911 10.774C28.8195 9.63799 28.1283 8.60594 27.2569 7.73687C26.3856 6.8678 25.3513 6.17876 24.2131 5.70915C23.0749 5.23953 21.8551 4.99856 20.6236 5.00001V5.00001Z",
    fill: "url(#paint1_linear_931_20787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6236 5V9.67876C21.8663 9.67876 23.058 10.1717 23.9367 11.0491C24.8154 11.9266 25.309 13.1166 25.309 14.3575C25.309 14.4387 25.309 14.5199 25.309 14.5997C25.2478 15.7875 24.7359 16.9075 23.8773 17.7319C23.0187 18.5562 21.878 19.0231 20.687 19.0377H20.5657C18.3024 19.0477 16.1199 19.8792 14.425 21.377C16.1203 22.8744 18.3025 23.7057 20.5657 23.7164H20.687C23.1215 23.7022 25.4549 22.7424 27.1932 21.0403C28.9314 19.3381 29.9381 17.0273 30 14.597C30 14.5158 30 14.436 30 14.3548C29.9996 13.1257 29.7568 11.9087 29.2854 10.7734C28.8139 9.63803 28.1231 8.60655 27.2524 7.73784C26.3817 6.86913 25.3481 6.18022 24.2107 5.71046C23.0733 5.2407 21.8544 4.99928 20.6236 5Z",
    fill: "url(#paint2_linear_931_20787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2871 5.06738V9.47092H12.5453H15.6969V6.25909V5.06738H11.2871Z",
    fill: "#444CE7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 39.8,
    height: 39.8,
    rx: 7.9,
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_931_20787",
    x: -5,
    y: 15,
    width: 50,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_931_20787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_931_20787",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_931_20787",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_931_20787",
    x1: 25.1947,
    y1: 19.5702,
    x2: 12.8588,
    y2: 5.47111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_931_20787",
    x1: 21.9548,
    y1: 19.672,
    x2: 24.8353,
    y2: 4.38476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F56D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444CE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_20787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_931_20787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 31.25,
    fill: "white",
    transform: "translate(11.25 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkLogo);
export default __webpack_public_path__ + "static/media/icon_mark_logo.8bca477cd8fe76567c81c8ac44f72e6d.svg";
export { ForwardRef as ReactComponent };